import api from "../utils/axios/axiosConfig";

const transferHistoryService = {
  search: (id, params) => api.post(`/transfer-history/search/${id}`, params),
  searchAll: (params) => api.post("/transfer-history/search-all", params),
  get: (id) => api.get(`/transfer-history/get/${id}`),
  addBalance: (data) => api.post("/transfer-history/add-balance", data),
  changeStatus: (id, data) => api.put(`/transfer-history/change-status/${id}`, data),
  transferBetweenAccounts: (data) => api.post("/transfer-history/transfer-between-accounts", data),
  withdrawBalance: (data) => api.post("/transfer-history/withdraw-balance", data),
};

export default transferHistoryService;
